import { AudioOutlined, FileTextOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { MessageTypeEnum } from 'api/MessagesApi';

type AllProps = {
  type: MessageTypeEnum;
  color?: string;
};

function MessageIcon({ type, color }: AllProps) {
  const style = color ? { color } : undefined;

  if (type === MessageTypeEnum.Video) {
    return <VideoCameraOutlined style={style} />;
  } else if (type === MessageTypeEnum.Audio) {
    return <AudioOutlined style={style} />;
  } else {
    return <FileTextOutlined style={style} />;
  }
}
export default MessageIcon;
